// @flow

import type OrderApiClientInterface from '../order-api/order-api-client-interface'
import type { Subscription, AbtSubscription } from '../types/subscription'
import { formatDeeplinkDate, parseOrderApiDate } from '../utils/date'

export default class SubscriptionManager {
  orderApiClient: OrderApiClientInterface

  constructor (orderApiClient: OrderApiClientInterface) {
    this.orderApiClient = orderApiClient
  }

  async buildSubscriptionRenewalDeeplinkParameters (token: string) {
    const subscription: Subscription = await this.orderApiClient.getSubscriptionByToken(token)
    const productData = {}
    if (subscription.zoneId) {
      productData.zoneId = subscription.zoneId
    }
    if (subscription.starValue) {
      productData.starValue = subscription.starValue
    }
    if (subscription.fromStopId) {
      productData.fromStop = subscription.fromStopId
    }
    if (subscription.toStopId) {
      productData.toStop = subscription.toStopId
    }
    return {
      'tariffTerm[0]': subscription.tariffTermId,
      customerGroup: subscription.customerGroupId,
      productGroupId: subscription.productGroupId,
      'productType[0]': subscription.productTypeId,
      class: subscription.class,
      dateEffective: formatDeeplinkDate(parseOrderApiDate(subscription.dateEffective || '')),
      engravedId: subscription.engravedId,
      product_data: JSON.stringify(productData),
      renewSubscription: subscription.subscriptionId
    }
  }

  async buildAbtSubscriptionRenewalDeeplinkParameters (token: string) {
    const subscription: AbtSubscription = await this.orderApiClient.getSubscriptionByToken(token)
    const productData = {}
    if (subscription.zoneSlug) {
      productData.zoneId = subscription.zoneSlug
    }
    if (subscription.starValue) {
      productData.starValue = subscription.starValue
    }
    if (subscription.fromStationSlug) {
      productData.fromStop = subscription.fromStationSlug
    }
    if (subscription.toStationSlug) {
      productData.toStop = subscription.toStationSlug
    }
    return {
      'propositionTerm[0]': subscription.propositionTermSlug,
      customerGroup: subscription.customerGroupSlug,
      proposition: subscription.propositionSlug,
      dateEffective: formatDeeplinkDate(parseOrderApiDate(subscription.dateEffective || '')),
      engravedId: subscription.engravedId,
      product_data: JSON.stringify(productData),
      renewSubscription: subscription.publicId
    }
  }
}



// WEBPACK FOOTER //
// ./src/subscription/subscription-manager.js